var provider = {
	safe_color_names: [
		'preto', 'marrom', 'verde', 'roxo', 'azul', 'laranja',
		'cinza', 'amarelo', 'branco','vermelho', 'violeta'
	],

	color_names: [
		'Azul', 'Azul claro', 'Azul marinho', 'Azul celeste', 'Azul cobalto', 'Azul turquesa',
		'Amarelo', 'Amarelo claro', 'Amarelo Mostarda', 'Âmbar', 'Ametista',
		'Bege', 'Bordô', 'Branco', 'Branco gelo', 'Bronze', 'Caramelo',
		'Carmesin', 'Caqui', 'Coral', 'Castanho', 'Cereja', 'Chocolate',
		'Ciano', 'Cinza', 'Cinza claro', 'Cinza escuro', 'Cobre', 'Creme', 'Dourado',
		'Esmeralda', 'Ferrugem', 'Grená', 'Índigo', 'Laranja', 'Lilás', 'Madeira',
		'Magenta', 'Magenta escuro', 'Marfim', 'Marrom', 'Marrom claro', 'Oliva',
		'Oliva escura', 'Prata', 'Púrpura', 'Preto', 'Rosa', 'Rosa choque', 'Roxo',
		'Salmão', 'Sépia', 'Turquesa', 'Verde', 'Verde claro', 'Verde escuro', 'Verde limão',
		'Vermelho', 'Vermelho escuro', 'Vermelho claro', 'Vermelhor tijolo', 'Violeta'
	]
};

module.exports = provider;